module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/090-burkina-faso-500582d7e39471ca6d687aa4e3bef9dd.svg";